export const LOOKER_NAME = "looker";
export const LOOKER_DISPLAY_NAME = "Looker";

export const BASE_URL_PREFIX = `/config/${LOOKER_NAME}`;
